import PopupActions from '../../../actions/PopupActions';
import PosCartActions from '../../../actions/PosCartActions';
import PosCartStore from '../../../stores/PosCartStore';
import AjaxPromises from '../../../utils/AjaxPromises';
import UserStore from '../../../stores/UserStore';
import NotificationActions from '../../../actions/NotificationActions';
import { endPoints as SpringBigEndpoints } from '../../../constants/SpringBigConstants';

class SpringBigOffer extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            adding: false,
        }

        this.addOffer = this.addOffer.bind(this);
    }

    addOffer() {
        if(this.state.adding) {
            return;
        }

        this.setState({ adding: true });

        AjaxPromises.POST(SpringBigEndpoints.APPLY_OFFER, UserStore.getApiData({
            ShipmentId: this.props.guest.ShipmentId,
            AllocatedInventoryId: this.props.cart.InventoryId,
            ProductId: this.props.cart.ProductId,
            CustomerId: this.props.guest.Guest_id,
            SerialNumber: this.props.cart.SerialNo,
            OfferToApply: this.props.offer,
        })).then(resp => {
            this.setState({ adding: false });
            if(!resp.Result) {
                NotificationActions.error(`Error Applying Offer: ${resp.Message}`);
            }

            PosCartActions.loadUserCart(this.props.guest.Guest_id, this.props.guest.ShipmentId);
            this.props.onClose();
        });
    }

    render() {
       
        return (
           <div className='springbig-reward'>
               <div className='row'>
                <div className='col-md-6'><h3 className='springbig-reward-name'>{this.props.offer.name}</h3></div>
                <div className='col-md-6 pull-right'><span className='springbig-text'>Expires:</span> {moment(this.props.offer.expiration).format("MM/DD/YYYY")}</div>
            </div>
            <div className='row'>
                <div className='col-md-12'>{<img className='springbig-img' width={100} height={100} src={(this.props.offer.images && this.props.offer.images.length > 0) ? this.props.offer.images[0].thumb : '/assets/id_placeholder.png'} /> }
                <div className='springbig-reward-info'>
                    <div><span className='springbig-text'>Max Redemptions:</span> {this.props.offer.max_redemptions}</div>
                    <div><span className='springbig-text'>Redemptions Remaining: </span>{this.props.offer.redemptions_available}</div>
                </div>
                </div>
            </div>
               
                <div className='pull-right'>
                    <button className='btn-green' disabled={this.state.adding} onClick={this.addOffer}>Add</button>
                </div>

           </div>
        );
    }
}

export default SpringBigOffer;


// WEBPACK FOOTER //
// ./ui_src/app/components/pos/springbig-redeem/SpringBigOffer.react.jsx